import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

function AddressForm({
  onChange,
  firstName,
  lastName,
  email,
  phone,
  address1,
  address2,
  city,
  state,
  zip,
  country,
  addToMailingList,
}) {
  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="firstName"
            name="firstName"
            label="First name"
            fullWidth
            autoComplete="fname"
            value={firstName}
            onChange={e => onChange('firstName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="lastName"
            name="lastName"
            label="Last name"
            fullWidth
            autoComplete="lname"
            value={lastName}
            onChange={e => onChange('lastName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="email"
            name="email"
            label="Email"
            fullWidth
            autoComplete="billing email"
            value={email}
            onChange={e => onChange('email', e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                name="addToMailingList"
                checked={addToMailingList}
                onChange={e => onChange('addToMailingList', e.target.checked)}
              />
            }
            label="Would you like to be notified of updates to my catalogues and lists?"
          />
        </Grid>
      </Grid>
      <br />
      <Typography variant="h6" gutterBottom>
        Shipping address
      </Typography>
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <TextField
            id="address1"
            name="address1"
            label="Address line 1"
            fullWidth
            autoComplete="billing address-line1"
            value={address1}
            onChange={e => onChange('address1', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="address2"
            name="address2"
            label="Address line 2"
            fullWidth
            autoComplete="billing address-line2"
            value={address2}
            onChange={e => onChange('address2', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="city"
            name="city"
            label="City"
            fullWidth
            autoComplete="billing address-level2"
            value={city}
            onChange={e => onChange('city', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="state"
            name="state"
            label="State/Province/Region"
            fullWidth
            value={state}
            onChange={e => onChange('state', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="zip"
            name="zip"
            label="Zip / Postal code"
            fullWidth
            autoComplete="billing postal-code"
            value={zip}
            onChange={e => onChange('zip', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="country"
            name="country"
            label="Country"
            fullWidth
            autoComplete="billing country"
            value={country}
            onChange={e => onChange('country', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="phone"
            name="phone"
            label="Telephone"
            fullWidth
            autoComplete="billing phone"
            value={phone}
            onChange={e => onChange('phone', e.target.value)}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

AddressForm.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default AddressForm
